import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PrivateRoute from '@/components/PrivateRoute';
import { useUserRoles } from '@/hooks/useUserRoles';

type ReviewerRouteProps = {
  children: React.ReactNode;
};

export default function ReviewerRoute({ children }: ReviewerRouteProps) {
  const location = useLocation();
  const { isAdmin, isReviewer, loading } = useUserRoles();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!loading) setReady(true);
  }, [loading]);

  if (!ready) {
    return (
      <PrivateRoute>
        <div className="flex min-h-[40vh] items-center justify-center text-white/50 font-sans">
          Checking reviewer access…
        </div>
      </PrivateRoute>
    );
  }

  if (!isReviewer && !isAdmin) {
    return <Navigate to="/home" replace state={{ from: location.pathname }} />;
  }

  return <PrivateRoute>{children}</PrivateRoute>;
}
